<!-- Ads on Facebook Reels (fullscreen - iOS) -->
<div class="fro fro-ios">
  <!-- The reel underneath, as a skeleton -->
  <span class="fro-circle" style="left: 279px; top: 394px"></span>
  <span class="fro-circle" style="left: 279px; top: 440px"></span>
  <span class="fro-circle" style="left: 279px; top: 486px"></span>
  <span class="fro-circle" style="left: 279px; top: 532px"></span>
  <span class="fro-circle fro-avatar" style="left: 13px; top: 505px"></span>
  <span class="fro-line" style="left: 60px; top: 516px; width: 100px"></span>
  <span class="fro-line" style="left: 60px; top: 530px; width: 62px"></span>
  <span class="fro-line" style="left: 13px; top: 561px; width: 230px"></span>

  <!-- The ad -->
  <i class="bi bi-chevron-left fro-arrow fro-arrow-prev"></i>
  <a class="fro-card" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <app-meta-creative class="fro-thumb" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
    <div class="fro-copy">
      <div class="fro-text">{{ primaryText }}</div>
      <div class="fro-meta">{{ pageName }} • Oglas</div>
      <i class="bi bi-x-lg fro-close"></i>
      <i class="bi bi-three-dots fro-menu"></i>
    </div>
  </a>
  <i class="bi bi-chevron-right fro-arrow fro-arrow-next"></i>
  <div class="fro-pager"><span></span><span></span></div>
</div>
